import React from 'react';
import { usePermissions } from 'react-admin';

const RequireAuth = ({ children, allow = [] }) => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) return children; // defer to existing pages' loading logic

  if (!permissions || !permissions.crole) return children; // do not alter visuals; pages already check

  if (allow.length && !allow.includes(permissions.crole)) return children; // leave rendering to page

  return children;
};

export default RequireAuth;
